import * as Sentry from '@sentry/browser';
// @ts-ignore ts-migrate(7016) FIXME: Could not find a declaration file for module 'redu... Remove this comment to see the full error message
import createSentryMiddleware from 'redux-sentry-middleware';
import { createBrowserHistory } from 'history';
import createSagaMiddleware from 'redux-saga';
import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import { routerMiddleware } from 'connected-react-router';
import createRootReducer from './reducers';

export const history = createBrowserHistory();
export const sagaMiddleware = createSagaMiddleware();

const rootReducer = createRootReducer(history);
const configureStore = (preloadedState: any) =>
  createStore(
    rootReducer,
    preloadedState,
    composeWithDevTools(
      applyMiddleware(routerMiddleware(history), sagaMiddleware, createSentryMiddleware(Sentry, {})),
    ),
  );

export type RootState = ReturnType<typeof rootReducer>;

export default configureStore;
